<svg width="24" height="24" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g transform="matrix(1,0,0,1,4,4)">
        <path d="M1.65,15.826C2.225,15.113 2.565,14.205 2.67,13.102C1.032,11.727 0,9.729 0,7.505C0,3.36 3.582,0 8,0C12.418,0 16,3.36 16,7.505C16,11.65 12.418,15.01 8,15.01C7.309,15.01 6.638,14.927 5.999,14.773C4.741,15.899 3.291,16.25 1.65,15.826Z"/>
    </g>
</svg>
